<template>
  <div class="ed-items">
    <div class="ed-items__head">
      <span class="ed-label mb-0">{{ title }} <span class="ed-help">· {{ items.length }}</span></span>
      <v-btn small depressed color="primary" class="ed-items__new" @click="$emit('new')">
        <i class="fal fa-plus mr-2"></i>{{ newLabel }}
      </v-btn>
    </div>
    <div v-if="!items.length" class="ed-empty">Nenhum item cadastrado.</div>
    <ul v-else class="ed-items__list">
      <li v-for="item in items" :key="item.id" class="ed-item" :class="{ 'ed-item--inactive': !item.active }">
        <div class="ed-item__thumb" :style="item.imagePath ? { backgroundImage: 'url(' + item.imagePath + ')' } : null">
          <i v-if="!item.imagePath" class="fal fa-image"></i>
        </div>
        <div class="ed-item__main">
          <div class="ed-item__name">
            {{ item.name }}
            <span v-if="!item.active" class="ed-item__badge">Inativo</span>
          </div>
          <div class="ed-help">
            {{ valueText(item) }}<span v-if="showDrawQuantity"> · {{ item.numberDrawQuantity || "sem" }} número(s) da sorte</span>
          </div>
        </div>
        <div class="ed-item__actions">
          <v-btn small flat icon title="Editar" @click="$emit('edit', item)"><i class="fal fa-pen"></i></v-btn>
          <v-btn small flat icon :title="item.active ? 'Inativar' : 'Ativar'" @click="$emit('toggle', item)">
            <i :class="item.active ? 'fal fa-eye-slash' : 'fal fa-eye'"></i>
          </v-btn>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
// Lista compacta de produtos/brindes (sem carregar perguntas nem o objeto completo).
export default {
  name: "EditorProductList",
  props: {
    newLabel: { type: String, default: "Novo" },
    title: { type: String, required: true },
    items: { type: Array, default: () => [] },
    showDrawQuantity: Boolean,
  },
  methods: {
    valueText(item) {
      const money = (value) => `R$ ${Number(value).toLocaleString("pt-BR")}`;
      if (item.openValue) return "Valor aberto";
      if (item.fixedValue) return money(item.fixedValue);
      if (item.initialValue && item.finalValue) return `${money(item.initialValue)} a ${money(item.finalValue)}`;
      if (item.initialValue) return `A partir de ${money(item.initialValue)}`;
      if (item.finalValue) return `Até ${money(item.finalValue)}`;
      return "Sem faixa de valor";
    },
  },
};
</script>

<style scoped>
.ed-items + .ed-items {
  margin-top: 20px;
}
.ed-items__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
}
.ed-items__new {
  text-transform: none;
  font-weight: 600;
  border-radius: 999px;
}
.ed-items__list {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid var(--ced-border, #e3e5ec);
  border-radius: 8px;
}
.ed-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 12px;
}
.ed-item + .ed-item {
  border-top: 1px solid var(--ced-border, #e3e5ec);
}
.ed-item--inactive .ed-item__main {
  opacity: 0.55;
}
.ed-item__thumb {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 6px;
  background: #f1f2f5 center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c3c6d5;
}
.ed-item__main {
  flex: 1;
  min-width: 0;
}
.ed-item__name {
  font-weight: 600;
  font-size: 14px;
}
.ed-item__badge {
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 999px;
  background: #f1f2f5;
  color: #5f6377;
  font-size: 11px;
  font-weight: 600;
}
.ed-item__actions {
  display: flex;
}
</style>
